/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TopBudgetByTenantWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("TopBudgetByTenantWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return TopBudgetByTenantWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TopBudgetByTenantWidgetConfiguration>): TopBudgetByTenantWidgetConfiguration {
        let obj = Object.assign(new TopBudgetByTenantWidgetConfiguration(), model);
        TopBudgetByTenantWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TopBudgetByTenantWidgetConfiguration>): TopBudgetByTenantWidgetConfiguration {
        if (!model) return null;
        return TopBudgetByTenantWidgetConfiguration.newInstance(<TopBudgetByTenantWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TopBudgetByTenantWidgetConfiguration) {
        if (!obj) return;

        models.TopBudgetByTenantWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TopBudgetByTenantWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TopBudgetByTenantWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
